<app-dashboard-block-layout [label]="label" [labelIcon]="labelIcon">
  <div class="pb-4 h-full">
    <p-chart height="100%" [type]="type" [data]="data" [options]="options"></p-chart>
  </div>
</app-dashboard-block-layout>
